/**
 * usage:   <common-sidebar active="'首页'"></common-sidebar>
 *          <common-sidebar size="'small'" active="'数据分析'"></common-sidebar>
 *          <common-sidebar size="'small'" show-secondary="'true'" active="'数据分析'"></common-sidebar>
 * require: font-awesome.min.css
 */

!(function () {
    angular
        .module('DSSXAPP')
        .component('commonSidebar', {
            template:'<div class="common-sidebar-view" ng-class="{\'common-sidebar-view-small\': vm.d.size === \'small\', \'common-sidebar-scroll\': vm.d.scrollTop > 60, \'common-sidebar-preview\': vm.d.isPreviewMode}" ng-mouseleave="vm.f.showSmallItem()"><div class="common-sidebar-addition"><div ng-transclude></div></div><div class="common-sidebar-secondary" ng-if="vm.d.size === \'small\' && vm.showSecondary"><div ng-repeat="menu in vm.d.menus track by $index" ng-if="menu.title === vm.active"><div class="common-sidebar-secondary-title"><span><a ng-href="{{vm.disabled ? \'\' : menu.href}}">{{menu.title}}</a></span></div><hr align="left"><div class="common-sidebar-secondary-menu"><div class="common-sidebar-secondary-top"><ul><li ng-repeat="top in menu.topItems track by $index"><a ng-href="{{vm.disabled ? \'\' : top.href}}">{{top.title}}</a></li></ul></div><div class="common-sidebar-secondary-list"><ul><li ng-repeat="sub in menu.subItems track by $index"><span>{{sub.title}}</span><ul><li ng-repeat="item in sub.subItems track by $index"><a ng-href="{{vm.disabled ? \'\' : item.href}}">{{item.title}}</a></li></ul></li></ul></div></div></div></div><div class="common-sidebar-shortcut-large" ng-show="vm.d.size !== \'small\'" ng-mouseover="vm.f.showLargeItem()"><span>快捷入口</span> <i class="iconfont icon-set" ng-click="vm.f.openShortcutSetting()"></i><ul><li ng-repeat="shortcut in vm.d.shortcut track by $index"><a ng-href="{{vm.disabled ? \'\' : shortcut.href}}">{{shortcut.title}}</a></li></ul></div><ul ng-show="vm.d.size === \'small\'" ng-mouseover="vm.f.showLargeItem()"><li class="common-sidebar-small-shortcut" ng-class="{\'is-opened\': vm.d.isOpened[$index - 1]}" ng-mouseover="vm.f.showFloatItem($index - 1)" ng-mouseleave="vm.f.hideFloatItem($index - 1)"><div class="common-sidebar-main"><a href="javascript:;"><i class="seller-menu-icon seller-menu-icon-quick"></i></a></div><div class="common-sidebar-item" ng-style="vm.f.getSidebarItemStyle($index - 1)"><div class="common-sidebar-item-title"><span><a>快捷入口</a></span></div><div class="common-sidebar-item-list"><ul><li><ul><li ng-repeat="shortcut in vm.d.shortcut track by $index"><a ng-href="{{vm.disabled ? \'\' : shortcut.href}}">{{shortcut.title}}</a></li></ul></li></ul></div></div></li></ul><ul ng-mouseover="vm.f.showLargeItem()"><li ng-repeat="menu in vm.d.menus track by $index" ng-class="{\'active\': menu.title === vm.active, \'is-opened\': vm.d.isOpened[$index]}" ng-mouseover="vm.f.showFloatItem($index)" ng-mouseleave="vm.f.hideFloatItem($index)"><div class="common-sidebar-main"><a ng-href="{{vm.disabled ? \'\' : menu.href}}"><i class="fa" ng-class="menu.icon"></i> <span class="common-sidebar-title">{{menu.title}}</span></a> <i class="iconfont icon-more" ng-show="menu.subItems.length"></i> <i class="common-sidebar-remind" ng-show="menu.tip === \'new\'"></i></div><div class="common-sidebar-item" ng-show="menu.subItems.length" ng-style="vm.f.getSidebarItemStyle($index)"><div class="common-sidebar-item-title"><span><a ng-href="{{vm.disabled ? \'\' : menu.href}}">{{menu.title}}</a></span></div><div class="common-sidebar-item-top"><ul><li ng-repeat="top in menu.topItems track by $index"><a ng-href="{{vm.disabled ? \'\' : top.href}}">{{top.title}}</a></li></ul></div><div class="common-sidebar-item-list"><ul><li ng-repeat="sub in menu.subItems track by $index"><span>{{sub.title}}</span><ul><li ng-repeat="item in sub.subItems track by $index"><a ng-href="{{vm.disabled ? \'\' : item.href}}">{{item.title}} <span class="common-sidebar-item-list-new-tip" ng-show="item.tip === \'new\'">NEW</span> <span class="common-sidebar-item-list-hot-tip" ng-show="item.tip === \'hot\'">HOT</span></a></li></ul></li></ul></div></div></li></ul><ul ng-mouseover="vm.f.showLargeItem()"><li ng-repeat="menu in vm.d.services track by $index" ng-class="{\'active\': menu.title === vm.active, \'is-opened\': vm.d.isOpened[$index + 13]}" ng-mouseover="vm.f.showFloatItem($index + 13)" ng-mouseleave="vm.f.hideFloatItem($index + 13)"><div class="common-sidebar-main"><a ng-href="{{vm.disabled ? \'\' : menu.href}}"><i class="fa" ng-class="menu.icon"></i> <span class="common-sidebar-title">{{menu.title}}</span></a> <i class="iconfont icon-more" ng-show="menu.subItems.length"></i></div><div class="common-sidebar-item" ng-show="menu.subItems.length" ng-style="vm.f.getSidebarItemStyle($index + 13)"><div class="common-sidebar-item-title"><span><a ng-href="{{vm.disabled ? \'\' : menu.href}}">{{menu.title}}</a></span></div><div class="common-sidebar-item-list"><ul><li ng-repeat="sub in menu.subItems track by $index"><span>{{sub.title}}</span><ul><li ng-repeat="item in sub.subItems track by $index"><a ng-href="{{vm.disabled ? \'\' : item.href}}">{{item.title}}</a></li></ul></li></ul></div></div></li><li ng-click="vm.f.handlePreview()"><div class="common-sidebar-main"><a href="javascript:;"><i class="fa fa-eye"></i> <span class="common-sidebar-title">{{\'实训平台预览地址\'}}</span></a></div></li></ul></div>',
            bindings: {
                size: '<',
                active: '<',
                disabled: '<',
                showSecondary: '<', // 是否展示二级菜单
                hoverEnlarge: '<' // 鼠标悬停是否放大补全菜单
            },
            transclude: true,
            controllerAs: 'vm',
            controller: ['$scope', '$q', '$timeout', 'request', 'event', function ($scope, $q, $timeout, request, event) {
                var vm = this;

                vm.d = {
                    menus: [
                        newItem('seller-menu-icon seller-menu-icon-home', '首页', '/index.html', [], [], ''),
                        newItem('seller-menu-icon seller-menu-icon-store', '店铺管理', '/usr/api/jumpToManageStore?m=NO_C&token=' + DSSX.util.getToken(), [
                            newItem('', '全球旺铺', '/usr/api/jumpToManageStore?m=NO_C&token=' + DSSX.util.getToken(), [], [], ''),
                            newItem('', '管理公司信息', '/company-msg.html', [], [], '')
                        ], [
                            newItem('', '管理全球旺铺', '', [], [
                                newItem('', '无线旺铺', '', [], [], ''),
                                newItem('', '域名管理', '', [], [], ''),
                                newItem('', '模板市场', '', [], [], '')
                            ], ''),
                            newItem('', '公司介绍', '', [], [
                                newItem('', '贸易记录', '', [], [], '')
                            ], ''),
                            newItem('', '认证信息', '', [], [
                                newItem('', 'A&V认证', '/post-auth-info.html', [], [], ''),
                                newItem('', '能力评估报告', '', [], [], ''),
                                newItem('', '金品诚企认证', '', [], [], ''),
                                newItem('', '', '', [], [], ''),
                                newItem('', '全球E站', '/usr/api/jumpToManageStore?m=NO_C&token=' + DSSX.util.getToken(), [], [], '')
                            ], ''),
                            // newItem('', '全球E站', '', [], [
                            //     newItem('', '查看店铺', '/usr/api/jumpToStore?url=%2Fshop.html%3FstoreId%3D&m=NO_C&token=' + DSSX.util.getToken(), [], [], ''),
                            //     newItem('', '装修店铺', '/usr/api/jumpToManageStore?m=NO_C&token=' + DSSX.util.getToken(), [], [], ''),
                            //     newItem('', '域名管理', '', [], [], '')
                            // ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-safe_fill', '认证中心', '', [
                            newItem('', '证书管理', '/certification-authority/certification-manage.html', [], [], '')
                        ], [
                            newItem('', '会员认证', '', [], [
                                newItem('', '证书上传', '/certification-authority/certification-upload/certification-check.html', [], [], ''),
                                newItem('', '实地认证', '', [], [], ''),
                                newItem('', '金品认证', '', [], [], ''),
                                newItem('', '认证报告', '', [], [], '')
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-product', '产品管理', '/product-manage.html', [
                            newItem('', '发布产品', '/product-post.html', [], [], ''),
                            newItem('', '管理产品', '/product-manage.html', [], [], '')
                        ], [
                            newItem('', '产品运营', '', [], [
                              newItem('', '产品运营工作台', '', [], [], ''),
                              newItem('', '行业定向征品', '', [], [], ''),
                              newItem('', '产品定制中心', '', [], [], ''),
                              newItem('', '产品目录', '', [], [], ''),
                              newItem('', '产品分组与排序', '/manage-products-group.html', [], [], ''),
                              newItem('', '管理平台新品', '', [], [], ''),
                              newItem('', '管理认证产品', '', [], [], ''),
                              newItem('', '回收站', '', [], [], ''),
                              newItem('', '学习中心', '', [], [], '')
                            ], ''),
                            newItem('', '工具中心', '', [], [
                                newItem('', '管理图片银行', '/photo-bank.html', [], [], ''),
                                newItem('', '管理视频银行', '', [], [], ''),
                                newItem('', '编辑导航模板', '', [], [], ''),
                                newItem('', '批量投放管理', '', [], [], ''),
                                newItem('', '批量上传', '', [], [], ''),
                                newItem('', '全文搜索工具', '', [], [], ''),
                                newItem('', '产品提效工具', '', [], [], ''),
                                newItem('', '3D家居场景购', '', [], [], '')
                            ], ''),
                            newItem('', '搜索诊断', '', [], [
                                newItem('', '搜索诊断首页', '', [], [], ''),
                                newItem('', '供应商诊断优化', '', [], [], ''),
                                newItem('', '关键词诊断优化', '', [], [], ''),
                                newItem('', '产品诊断优化', '', [], [], ''),
                                // newItem('', '排名查询工具', '', [], [], ''),
                                // newItem('', '学习中心', '', [], [], '')
                            ], ''),
                            // newItem('', '管理产品', '', [], [
                            //   newItem('', '产品分组与排序', '/manage-products-group.html', [], [], ''),
                            //   newItem('', '管理橱窗产品', '/window-product-manage.html', [], [], ''),
                            //   newItem('', '管理认证产品', '', [], [], ''),
                            //   newItem('', '管理优商专区', '', [], [], ''),
                            //   newItem('', '关联出口产品', '', [], [], ''),
                            //   newItem('', '回收站', '', [], [], '')
                            // ], ''),
                            // newItem('', '多语言市场', '', [], [
                            //   newItem('', '多语言市场首页', '/multi-lang-market.html#!/index', [], [], '')
                            // ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-media', '媒体中心', '', [], [
                          newItem('', '视频', '', [], [
                            newItem('', '视频发布', '', [], [], ''),
                            newItem('', '发布管理', '', [], [], ''),
                            newItem('', '视频投稿', '', [], [], ''),
                            newItem('', '视频素材', '', [], [], ''),
                            newItem('', '内容等级', '', [], [], ''),
                            newItem('', '视频任务', '', [], [], ''),
                            newItem('', '视频数据', '', [], [], ''),
                            newItem('', 'SNS智能分享', '', [], [], ''),
                            newItem('', 'SNS账号管理', '', [], [], '')
                          ], ''),
                          newItem('', '直播', '', [], [
                            newItem('', '我的直播', '', [], [], ''),
                            newItem('', '直播管理', '', [], [], ''),
                            newItem('', '直播数据', '', [], [], '')
                          ], ''),
                          newItem('', '3D', '', [], [
                            newItem('', '3D家装场景购', '', [], [], ''),
                            newItem('', 'VR实景展厅', '', [], [], '')
                          ], ''),
                          newItem('', '多媒体学习中心', '', [], [
                            newItem('', '短视频拍摄白皮书', '', [], [], ''),
                            newItem('', '直播学习中心', '', [], [], '')
                          ], ''),
                          newItem('', '服务市场', '', [], [
                            newItem('', '视频拍摄服务', '', [], [], ''),
                            newItem('', '直播服务', '', [], [], '')
                          ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-message', '商机沟通', '/message/default-all.html', [
                            newItem('', '询盘', '/message/default-all.html', [], [], ''),
                            newItem('', 'RFQ市场', '/rfq-index.html', [], [], '')
                        ], [
                            newItem('', '商机管理中心（询盘）', '', [], [
                                newItem('', '客户', '/client-manage.html', [], [], ''),
                                newItem('', '邮箱', '', [], [], ''),
                                newItem('', '设置', '/opportunity-management-set.html', [], [], '')
                            ], ''),
                            newItem('', '采购直达', '', [], [
                                newItem('', 'RFQ商机', '', [], [], ''),
                                newItem('', '报价管理', '/rfq/quotation-list.html', [], [], ''),
                                newItem('', '商机订阅', '/business-communication.html#!/business-subscription', [], [], ''),
                                newItem('', '我的报价权益', '/my-equity-detail.html', [], [], ''),
                                newItem('', '购买权益', '', [], [], ''),
                                newItem('', '我的买家', '', [], [], ''),
                                newItem('', '商业信息确认请求', '', [], [], '')
                                // newItem('', '企业信息验证', '', [], [], ''),
                                // newItem('', 'RFQ市场', '/rfq-index.html', [], [], ''),
                                // newItem('', '样品单管理', '', [], [], ''),
                                // newItem('', '发布采购需求', '/rfq-post.html', [], [], ''),
                                // newItem('', '我的采购', '', [], [], '')
                            ], ''),
                            newItem('', '工具和服务', '', [], [
                              newItem('', '商机获取提效工具', '', [], [], ''),
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-data', '数据分析', '/data-admin.html', [], [
                            newItem('', '店铺', '/data-admin.html#!/store-overview', [], [
                              newItem('', '数据概览', '/data-admin.html', [], [], ''),
                              newItem('', '产品分析', '/product-analyze.html', [], [], ''),
                              newItem('', '零效果产品', '/data-admin.html#!/self-product', [], [], ''),
                              newItem('', '视频分析', '', [], [], ''),
                              newItem('', '店铺分析', '', [], [], ''),
                              newItem('', '交易分析', '', [], [], ''),
                              newItem('', '履约分析', '', [], [], ''),
                              newItem('', '员工分析', '', [], [], '')
                            ], ''),
                            newItem('', '买家', '', [], [
                              newItem('', '流量来源', '/data-admin.html#!/traffic-source', [], [], ''),
                              newItem('', '引流关键词', '', [], [], ''),
                              newItem('', '访客画像', '', [], [], ''),
                              newItem('', '访客详情', '', [], [], '')
                            ], ''),
                            newItem('', '参谋', '', [], [
                              newItem('', '流量参谋', '', [], [], ''),
                              newItem('', '产品参谋', '', [], [], ''),
                              newItem('', '市场参谋', '', [], [], ''),
                              newItem('', '选词参谋', '', [], [], '')
                            ], ''),
                            newItem('', '市场', '', [], [
                              newItem('', '关键词指数', '/keyword-rate.html', [], [], ''),
                              newItem('', '行业报告', '', [], [], '')
                            ], ''),
                            newItem('', '营销', '', [], [
                              newItem('', '直通车效果', '', [], [], ''),
                              newItem('', '橱窗效果', '', [], [], ''),
                              newItem('', 'True View视频', '', [], [], '')
                            ], ''),
                            newItem('', '学堂', '', [], [
                              newItem('', '数据学堂', '', [], [], ''),
                              newItem('', '数据字典', '', [], [], '')
                            ], ''),
                            newItem('', '智能', '', [], [
                              newItem('', '智能运营', '', [], [], '')
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-customer', '客户管理', '/client/view.html', [
                            newItem('', '客户概览', '/client/view.html', [], [], '')
                        ], [
                            newItem('', '客户', '', [], [
                              newItem('', '客户列表', '/client/list.html', [], [], ''),
                              newItem('', '公海客户', '/client/public.html', [], [], ''),
                              newItem('', '客群管理', '/client/customer-group.html', [], [], ''),
                              newItem('', '客户分析', '', [], [], ''),
                              newItem('', '回收站', '/client/recycle-bin.html', [], [], '')
                            ], ''),
                            newItem('', '营销', '', [], [
                              newItem('', '营销活动', '/client/marketing-activity.html', [], [], ''),
                              newItem('', '模板管理', '/client/template-manage.html', [], [], '')
                            ], ''),
                            newItem('', '会员', '', [], [
                              newItem('', '会员设置', '', [], [], '')
                            ], ''),
                            newItem('', '设置', '', [], [
                              newItem('', '公海设置', '', [], [], ''),
                              newItem('', 'EDM设置', '', [], [], ''),
                              newItem('', '自定义品类', '/client/types.html', [], [], '')
                            ], ''),
                            newItem('', '快捷入口', '', [], [
                              newItem('', '访客详情', '', [], [], ''),
                              newItem('', '外贸邮', '', [], [], ''),
                              newItem('', '索要名片的请求', '', [], [], ''),
                              newItem('', '收到的名片', '', [], [], ''),
                              newItem('', '发出的名片', '', [], [], '')
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-marketing', '营销中心', '/marketing.html', [
                            // newItem('', '新贸节优惠券专场', '', [], [], ''),
                            // newItem('', '外贸直通车', '/marketing.html', [], [], '')
                            newItem('', '外贸直通车', '/marketing.html', [], [], ''),
                            newItem('', '外贸直通车-推荐', '', [], [], '')
                        ], [
                            newItem('', '商业营销中心', '', [], [
                                newItem('', '概览', '/marketing.html', [], [], ''),
                                newItem('', '顶级展位', '', [], [], ''),
                                newItem('', '橱窗', '/window-product-manage.html', [], [], ''),
                                newItem('', '明星展播', '', [], [], ''),
                                newItem('', '问鼎', '', [], [], ''),
                                newItem('', '品牌直达', '', [], [], '')
                            ], ''),
                            newItem('', '活动营销中心', '', [], [
                                newItem('', '官方活动报名', '/official-activity/all-activities.html', [], [], ''),
                                newItem('', '已报名活动', '/official-activity/my-activities.html', [], [], ''),
                                // newItem('', '新贸节攻略', '', [], [], ''),
                                newItem('', '线上展会指南', '', [], [], ''),
                                newItem('', '展会大厅', '', [], [], ''),
                                newItem('', '展会门票', '', [], [], ''),
                                newItem('', '展会报告', '', [], [], '')
                            ], ''),
                            newItem('', '商家自营销中心', '', [], [
                                newItem('', '折扣营销', '/marketing/activity.html', [], [], ''),
                                newItem('', '优惠券', '/marketing/coupon.html', [], [], ''),
                                newItem('', 'SNS智能分享', '', [], [], ''),
                                newItem('', 'SNS账号管理', '', [], [], ''),
                                newItem('', '场景搭配', '', [], [], ''),
                                // newItem('', '粉丝通', '', [], [], '')
                            ], ''),
                            newItem('', '工具和服务', '', [], [
                              newItem('', '关键词提效工具', '', [], [], ''),
                              newItem('', '直通车提效工具', '', [], [], ''),
                              newItem('', '视频营销服务', '', [], [], ''),
                            ], '')
                            // newItem('', '推荐有礼', '', [], [
                            //     newItem('', '推荐有礼', '', [], [], '')
                            // ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-order', '交易管理', '/oms.html', [
                            newItem('', '起草信用保障订单', '/draft-trusts.html', [], [], ''),
                            newItem('', '所有订单', '/oms.html', [], [], '')
                        ], [
                            newItem('', '订单管理', '', [], [
                                newItem('', '起草e收汇订单', '', [], [], 'new'),
                                newItem('', '运费模板', '/ship-templates.html', [], [], ''),
                                newItem('', '评价管理', '', [], [], ''),
                                newItem('', '退款管理', '/refund-manage.html', [], [], ''),
                                newItem('', '订单回收站', '', [], [], ''),
                            ], ''),
                            newItem('', '交易服务', '', [], [
                              newItem('', '交易营销工具', '', [], [], ''),
                              newItem('', '交易服务准入', '', [], [], ''),
                              newItem('', '额度管理', '', [], [], ''),
                              newItem('', '交易成长中心', '', [], [], ''),
                              newItem('', '海外现货管理', '', [], [], ''),
                            ], ''),
                            // newItem('', '信用保障服务', '', [], [
                            //     newItem('', '信用保障服务介绍', '', [], [], ''),
                            //     newItem('', '额度管理', '', [], [], '')
                            // ], ''),
                            newItem('', '增值服务', '', [], [
                                newItem('', '拒付保障服务', '', [], [], ''),
                                newItem('', 'OA赊销服务', '', [], [], ''),
                                newItem('', '验货服务', '', [], [], ''),
                                newItem('', '无忧退货保障', '', [], [], '')
                                // newItem('', '生产跟进服务', '', [], [], ''),
                                // newItem('', '备货融资', '', [], [], ''),
                                // newItem('', '尾款保障服务', '', [], [], ''),
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-global', '出口服务', '/place-order.html', [
                          newItem('', '立即下单', '/place-order.html', [], [], ''),
                          newItem('', '出口服务订单', '/place-order/export-orders.html', [], [], ''),
                        ], [
                          newItem('', '任务和服务', '', [], [
                            newItem('', '出口工作台', '/export-workbench.html', [], [], ''),
                            newItem('', '客户服务', '', [], [], 'new'),
                          ], ''),
                          newItem('', '下单准备', '', [], [
                            newItem('', '品牌管理', '/brand-manage.html', [], [], ''),
                            newItem('', '产品管理', '', [], [], ''),
                            newItem('', '开票人管理', '/drawer-manage/drawer-detail.html', [], [], ''),
                            newItem('', '开通诚e税', '', [], [], ''),
                          ], ''),
                          newItem('', '订单管理', '', [], [
                            newItem('', '服务售卖订单', '', [], [], ''),
                            newItem('', '快递出口订单', '', [], [], ''),
                            newItem('', '办证服务', '', [], [], ''),
                            newItem('', '业务预警', '', [], [], ''),
                            newItem('', '盖章服务', '', [], [], ''),
                          ], ''),
                          newItem('', '通关管理', '', [], [
                            newItem('', '报关单证制作', '', [], [], ''),
                            newItem('', '智慧税则', '', [], [], ''),
                            newItem('', '报关单证管理', '', [], [], ''),
                          ], ''),
                          newItem('', '退税管理', '', [], [
                            newItem('', '财税服务', '', [], [], ''),
                            newItem('', '退税SaaS软件', '', [], [], ''),
                            newItem('', '退税款查询', '', [], [], ''),
                            newItem('', '函调信息管理', '', [], [], ''),
                            newItem('', '退税发票管理', '', [], [], ''),
                            newItem('', '备案单证', '', [], [], ''),
                            newItem('', '代理证列表', '', [], [], ''),
                            newItem('', '垫付退税额度', '', [], [], ''),
                            // newItem('', '垫付退税大盘', '', [], [], ''),
                          ], ''),
                          // newItem('', '任务消息管理', '', [], [
                          //   newItem('', '任务待办', '', [], [], ''),
                          //   newItem('', '查看任务消息', '', [], [], ''),
                          // ], ''),
                          newItem('', '更多操作', '', [], [
                            newItem('', '数据中心', '', [], [], ''),
                            newItem('', '基础信息设置', '', [], [], ''),
                            newItem('', '供应链课堂', '', [], [], ''),
                            newItem('', '查看任务消息', '', [], [], ''),
                            // newItem('', '投诉与建议', '', [], [], ''),
                          ], ''),
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-delivery', '物流服务', '/logistics-query.html', [
                            newItem('', '查询报价并下单', '/logistics-query.html', [], [], ''),
                            // newItem('', '空快订单', '', [], [], '')
                        ], [
                            newItem('', '物流选择及报价', '', [], [
                                newItem('', '指定货代下单', '', [], [], '')
                            ], ''),
                            newItem('', '订单管理', '', [], [
                                newItem('', '海陆订单', '', [], [], ''),
                                newItem('', '空快订单', '', [], [], '')
                                // newItem('', '卖家物流委托单', '', [], [], ''),
                                // newItem('', '投诉工单', '', [], [], ''),
                            ], ''),
                            newItem('', '物流结算', '', [], [
                                newItem('', '海陆缴费', '', [], [], ''),
                                newItem('', '快递发票查询', '', [], [], '')
                            ], ''),
                            newItem('', '物流营销', '', [], [
                                newItem('', '物流客户权益', '', [], [], 'hot')
                                // newItem('', '我的优惠券', '', [], [], ''),
                                // newItem('', '快递下单立减', '', [], [], ''),
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-finance', '资金管理', '/fund-manage.html', [
                            newItem('', 'Alibaba.com Pay', '', [], [], '')
                        ], [
                            newItem('', '资金管理', '/fund-manage.html', [], [
                              newItem('', '资金总览', '/fund-manage.html', [], [], ''),
                              newItem('', '资金队长', '', [], [], '')
                            ], ''),
                            newItem('', '我的外汇', '', [], [
                              newItem('', '外汇到账列表', '', [], [], ''),
                              newItem('', '汇可视', '', [], [], ''),
                              newItem('', '托收管理', '', [], [], ''),
                              newItem('', '付款人备案', '', [], [], ''),
                              newItem('', '结汇', '', [], [], ''),
                              newItem('', '退汇', '', [], [], ''),
                              newItem('', '收汇账号', '', [], [], ''),
                              newItem('', '预警专区', '', [], [], ''),
                              newItem('', '锁汇宝', '', [], [], '')
                              // newItem('', '外汇评级', '', [], [], ''),
                              // newItem('', '对账单/资金明细', '', [], [], ''),
                            ], ''),
                            newItem('', '资金提款', '', [], [
                              newItem('', '发起提款', '', [], [], ''),
                              newItem('', '提现记录', '', [], [], ''),
                              newItem('', '账号与安全', '', [], [], ''),
                              newItem('', '提款课堂', '', [], [], '')
                              // newItem('', '提现/转款', '', [], [], ''),
                            ], ''),
                            newItem('', '缴费/发票/账号', '', [], [
                              newItem('', '费用缴纳', '', [], [], ''),
                              newItem('', '开发票', '', [], [], '')
                            ], ''),
                            newItem('', '金融服务', '', [], [
                              newItem('', '金融产品介绍', '', [], [], ''),
                              newItem('', '我的金融服务', '', [], [], 'hot'),
                              newItem('', '超级信用证', '', [], [], '')
                              // newItem('', '网商贷', '', [], [], ''),
                            ], ''),
                            // newItem('', '账号&结算设置', '', [], [
                            //   newItem('', '信保T/T收汇账号', '', [], [], ''),
                            //   newItem('', '一达通外汇子账号', '', [], [], ''),
                            //   newItem('', '自主出口体现账号', '', [], [], ''),
                            //   newItem('', '一达通体现账号', '', [], [], ''),
                            //   newItem('', '充值账号', '', [], [], ''),
                            //   newItem('', '缴费服务管理', '', [], [], ''),
                            //   newItem('', '支付宝国际账号', '', [], [], ''),
                            //   newItem('', '结汇方式', '', [], [], ''),
                            //   newItem('', '结算联系人设置', '', [], [], ''),
                            // ], ''),
                            // newItem('', '发票管理', '', [], [
                            //   newItem('', '发票申请', '', [], [], ''),
                            //   newItem('', '发票申请记录', '', [], [], ''),
                            // ], ''),
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-grow', '商家成长', '', [
                            newItem('', '商家星等级', '/star-rating.html', [], [], ''),
                            newItem('', '成长指引', '', [], [], '')
                        ], [
                            newItem('', '商家成长', '', [], [
                                newItem('', '商家学习', 'https://i.alibaba.com/supplier/training/xxindex.html', [], [], ''),
                                newItem('', '外贸云课堂', '', [], [], ''),
                                // newItem('', '外贸学院', 'https://peixun.alibaba.com', [], [], ''),
                                // newItem('', '外贸圈', 'https://waimaoquan.alibaba.com', [], [], ''),
                            ], '')
                        ], ''),
                        newItem('seller-menu-icon seller-menu-icon-service', '服务中心', '', [], [
                            newItem('', '规则中心', '', [], [
                                newItem('', '规则频道', 'https://rule.alibaba.com', [], [], ''),
                                newItem('', '投诉违规中心', '', [], [], ''),
                                newItem('', '知识产权保护', 'https://ipp.alibabagroup.com', [], [], ''),
                                newItem('', '申诉中心', '', [], [], '')
                            ], ''),
                            newItem('', '开放生态', '', [], [
                                newItem('', '外贸服务市场', '', [], [], ''),
                                newItem('', '我的服务订单', '', [], [], ''),
                                newItem('', '推荐服务', '', [], [], '')
                            ], ''),
                            newItem('', '账户中心', '', [], [
                                newItem('', '我的付费账户', '', [], [], ''),
                                newItem('', '账单列表', '', [], [], ''),
                                newItem('', '交易查询', '/complete-contract.html?orderId=CO596446c4d624d3276891a246', [], [], ''),
                                newItem('', '发票中心', '', [], [], ''),
                                newItem('', '产品代金券', '', [], [], '')
                            ], ''),
                            newItem('', '客户服务', '', [], [
                                newItem('', '客户服务中心', 'https://service.alibaba.com', [], [], ''),
                                newItem('', '关注客户中心微博', 'https://weibo.com/alibabaservice?is_hot=1', [], [], ''),
                                newItem('', '一达通客户服务', 'https://onetouch.alibaba.com', [], [], '')
                            ], '')
                        ], '')
                    ],
                    shortcut: [],
                    services: [],
                    scrollTop: 0,
                    isPreviewMode: DSSX.attr.isPreviewMode,
                    disablePreviewModeEntry: DSSX.appProp.moduleConf.disablePreviewModeEntry,
                    isOpened: [],
                    hideTimeout: [],
                };

                vm.f = {
                    openShortcutSetting: openShortcutSetting,
                    handlePreview: handlePreview,
                    showFloatItem: showFloatItem,
                    hideFloatItem: hideFloatItem,
                    showLargeItem: showLargeItem,
                    showSmallItem: showSmallItem,
                    getSidebarItemStyle: getSidebarItemStyle,
                };

                init();

                function init() {
                    setTimeout(function () {
                        vm.d.size = vm.size;
                    }, 0);

                    loadQuickEntryList();
                    event.on('common-sidebar.load-quick-entry-list', function () {
                        loadQuickEntryList();
                    });

                    $timeout(function () {
                        $(window).scroll(function () {
                            DSSX.util.debounce(function () {
                                vm.d.scrollTop = window.pageYOffset;
                                $timeout(function () {
                                    $scope.$apply();
                                });
                            }, 500, true)();
                        });
                    });

                    initExtraMenu()
                }

                /**
                 * 加载已添加的快捷列表入口
                 */
                function loadQuickEntryList() {
                    request.get('/usr/api/loadAccInfo', { returnField: 'quickEntry' }, true)
                        .then(function (res) {
                            vm.d.shortcut = [];
                            DSSX.util.safe(res, 'data.accInfo.quickEntry', []).forEach(function (element) {
                                vm.d.shortcut.push(newItem('', element.zhCN, element.url, [], [], ''));
                            });
                            window.localStorage.setItem('dssx_favorite_menu', JSON.stringify(DSSX.util.safe(res, 'data.accInfo.quickEntry', [])));
                        }, function (err) {
                            DSSX.dialog.err(err, {
                                moduleName: '快捷入口',
                                funcName: 'loadAddedQuickEntryList',
                                text: '加载已添加的快捷入口列表失败'
                            });
                        });
                }


                /**
                 * @param arg_icon {string} 图标
                 * @param arg_title {string} 标题
                 * @param arg_href {string} 超链接
                 * @param [arg_topItems] {array} 子菜单顶部超链接
                 * @param [arg_subItems] {array} 子菜单超链接
                 * @param [arg_tip] {String} 提示形式->'hot' 'new'
                 * @returns {{subItems: (*|Array), icon: (*|string), tip: (*|string), href: (*|string), title: (*|string), topItems: (*|Array)}}
                 */
                function newItem(arg_icon, arg_title, arg_href, arg_topItems, arg_subItems, arg_tip) {
                    return {
                        icon: arg_icon || '',
                        title: arg_title || '',
                        href: arg_href || '',
                        topItems: arg_topItems || [],
                        subItems: arg_subItems || [],
                        tip: arg_tip || ''
                    }
                }

                /**
                 * 打开快捷入口设置
                 */
                function openShortcutSetting() {
                    event.emit('common-sidebar.shortcut-setting', {});
                }

                /**
                 * 预览模式点击
                 */
                function handlePreview() {
                    event.emit('common-sidebar.handle-preview', {});
                }

                function initExtraMenu() {
                    // 注入 P4P统计任务
                    var userPermission = DSSX.userPermission || {}
                    if (userPermission.P4P_TASK_COUNT) {
                        injectP4PCountTaskMenu()
                    }
                }

                function injectP4PCountTaskMenu() {
                    console.log('[BaseSideBar] injectP4PCountTaskMenu')
                    var menus = vm.d.menus

                    // trick code: 直接用下标取出 营销中心 子菜单
                    var marketingSubMenu = menus[8]
                    if (!marketingSubMenu) {
                        return
                    }

                    var p4pSubMenu = newItem(
                        '',
                        '第三方插件',
                        '',
                        null,
                        [
                            newItem('', 'P4P统计任务', '/manage.html#!/p4p')
                        ]
                    )

                    marketingSubMenu.subItems.push(p4pSubMenu)
                }

                function showFloatItem (index) {
                    clearTimeout(vm.d.hideTimeout[index]);
                    vm.d.isOpened = [];
                    vm.d.isOpened[index] = true;
                }
                function hideFloatItem (index) {
                    vm.d.hideTimeout[index] = setTimeout(function () {
                        vm.d.isOpened[index] = false;
                        $scope.$apply();
                    }, 100);
                }

                function showLargeItem () {
                    if(vm.size === 'small' && vm.hoverEnlarge) {
                        vm.d.size = ''
                    }
                }
                function showSmallItem () {
                    if(vm.size === 'small' && vm.hoverEnlarge) {
                        vm.d.size = 'small'
                    }
                }

                function getSidebarItemStyle (index) {
                    var dom = document.getElementsByClassName('common-sidebar-main')[index + 1];
                    var windowHeight = $(window).height()
                    var bottom = dom.getBoundingClientRect().bottom;

                    if(windowHeight - bottom < windowHeight / 3) {
                        var bottom = windowHeight - bottom;
                        var maxHeight = windowHeight - bottom - 65;
                        var style = {'top': 'unset', 'bottom': bottom + 'px', 'max-height': maxHeight + 'px'};
                    } else if(windowHeight - bottom > windowHeight / 3 * 2) {
                        var top = dom.getBoundingClientRect().top;
                        var maxHeight = windowHeight - top - 5;
                        var style = {'top': top + 'px', 'bottom': 'unset', 'max-height': maxHeight + 'px'};
                    } else {
                        var maxHeight = windowHeight / 3 * 2;
                        var style = {'top': '50%', 'transform': 'translateY(-50%)', 'bottom': 'unset', 'max-height': maxHeight + 'px'};
                    }
                    return style;
                }
            }]
        });
})();
